<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 75vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Record" }} Family Planning Visit</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Visit Date *</label>
              <input type="datetime-local" v-model="form.visit_date" required class="form-control" />
            </div>
            <div class="form-group">
              <label>Visit Type</label>
              <select v-model="form.visit_type" class="form-control">
                <option value="">Select</option>
                <option value="New acceptor">New acceptor</option>
                <option value="Revisit">Revisit</option>
                <option value="Method switch">Method switch</option>
                <option value="Removal">Removal</option>
              </select>
            </div>
            <div class="form-group">
              <label>Provider</label>
              <input type="text" v-model="form.provider" class="form-control" />
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.counseling_provided" />
                Counseling provided
              </label>
            </div>
            <div class="form-group full-width" v-if="form.counseling_provided">
              <label>Counseling Notes</label>
              <textarea v-model="form.counseling_notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group">
              <label>Previous Method</label>
              <input type="text" v-model="form.previous_method" class="form-control" />
            </div>
            <div class="form-group">
              <label>Method Given</label>
              <select v-model="form.method_given" class="form-control">
                <option value="">Select</option>
                <option value="Combined pills">Combined pills</option>
                <option value="POP">Progestin-only pills (POP)</option>
                <option value="Injectable (DMPA)">Injectable (DMPA)</option>
                <option value="Implant">Implant</option>
                <option value="IUCD">IUCD</option>
                <option value="Condoms">Condoms</option>
                <option value="Bilateral tubal ligation">Bilateral tubal ligation</option>
                <option value="Vasectomy">Vasectomy</option>
                <option value="LAM">Lactational Amenorrhea (LAM)</option>
                <option value="Natural methods">Natural methods</option>
                <option value="None">None</option>
              </select>
            </div>
            <div class="form-group">
              <label>Method Start Date</label>
              <input type="date" v-model="form.method_start_date" class="form-control" />
            </div>
            <div class="form-group">
              <label>Quantity Given</label>
              <input type="text" v-model="form.quantity_given" class="form-control" />
            </div>
            <div class="form-group">
              <label>Batch Number</label>
              <input type="text" v-model="form.batch_number" class="form-control" />
            </div>

            <div class="form-group">
              <label>BP</label>
              <div class="bp-inputs">
                <input type="number" v-model="form.bp_systolic" placeholder="Systolic" class="form-control" />
                <span class="bp-separator">/</span>
                <input type="number" v-model="form.bp_diastolic" placeholder="Diastolic" class="form-control" />
              </div>
            </div>
            <div class="form-group">
              <label>Weight (kg)</label>
              <input type="number" v-model="form.weight_kg" step="0.1" class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Contraindications Screened</label>
              <textarea v-model="form.contraindications_screened" class="form-control" rows="2"></textarea>
            </div>
            <div class="form-group full-width">
              <label>Side Effects</label>
              <textarea v-model="form.side_effects" class="form-control" rows="2"></textarea>
            </div>
            <div class="form-group full-width">
              <label>Complications</label>
              <textarea v-model="form.complications" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group">
              <label>Next Appointment</label>
              <input type="date" v-model="form.next_appointment_date" class="form-control" />
            </div>
            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Visit" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../../api/apiIndex";

export default {
  name: "FpVisitModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        visit_date: this.toLocalDateTime(this.editRecord.visit_date),
        method_start_date: this.editRecord.method_start_date ? this.editRecord.method_start_date.substring(0, 10) : "",
        next_appointment_date: this.editRecord.next_appointment_date ? this.editRecord.next_appointment_date.substring(0, 10) : "",
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        visit_date: this.toLocalDateTime(new Date()),
        visit_type: "",
        provider: "",
        counseling_provided: false,
        counseling_notes: "",
        previous_method: "",
        method_given: "",
        method_start_date: "",
        quantity_given: "",
        batch_number: "",
        bp_systolic: "",
        bp_diastolic: "",
        weight_kg: "",
        contraindications_screened: "",
        side_effects: "",
        complications: "",
        next_appointment_date: "",
        notes: "",
      };
    },
    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`family_planning_records/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("family_planning_records", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save family planning visit");
        }
      } catch (error) {
        console.error("Error saving family planning visit:", error);
        alert("An error occurred while saving the visit");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #ed64a6 0%, #97266d 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.checkbox-label { display: flex !important; align-items: center; gap: 8px; margin-top: 28px; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.bp-inputs { display: flex; align-items: center; gap: 10px; }
.bp-inputs .form-control { flex: 1; }
.bp-separator { font-weight: bold; color: #495057; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #97266d; color: white; }
.btn-primary:hover { background: #702459; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 1200px) { .form-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
